import { instance } from './axios'
import { telegramBaseUrl, telegramCpUrl } from './index'

// 获取 tg 的 name 和 botId
export const apiTelegramBotInfo = data => instance.get(`${telegramBaseUrl}third/tg-bot/getBotId`, data)

// tg 绑定相关
export const apiHasBinding = data => instance.post(`${telegramCpUrl}telegram/hasBinding`, data)
export const apiUnbinding = data => instance.post(`${telegramCpUrl}telegram/unbinding`, data)
export const apiBinding = data => instance.post(`${telegramCpUrl}telegram/binding`, data)

// 官网 注册 API
export const apiTelegramRegistration = data =>
  instance.post(
    `${telegramBaseUrl}registrationV2/register`,
    {},
    {
      params: data,
    }
  )
